import { CivilUnionAnscNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-civil-union-non-resident/edit-person-search';
import { IdAmbito } from 'shell/constants/id-ambito';

const PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusShared
        scope={IdAmbito.Cancellazioni}
        items={CivilUnionAnscNotificationsNonResidentCancellationsCrumbs()}
      />
    </Fragment>
  );
};

PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusPage.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusPage;
